import React from 'react';
import { Grid, TextField, Button, Box, Typography, FormControl, InputLabel, Select, FormHelperText, MenuItem, ListSubheader } from '@mui/material';
import { doctorGroups, nurseGroups } from '../constants/options';

const SignaturesSection = ({ formData, handleSignatureOpen, handleNameChange, handleBlur, errors }) => {
  const signatureFields = [
    {
      label: "Anaesthetist",
      key: "anaesthesiologist_signature",
      key1: "anaesthesiologist_name",
      key2: "anaesthesiologist_date",
      key3: "anaesthesiologist_time",
      group: "AnaesthesiaSpecialists",
      type: "doctor"
    },
    {
      label: "Surgeon",
      key: "surgeon_signature",
      key1: "surgeon_name",
      key2: "surgeon_date",
      key3: "surgeon_time",
      groups: doctorGroups, // Pass all doctors
      type: "doctor_all"
    },
    {
      label: "Nurse",
      key: "nurse_signature",
      key1: "nurse_name",
      key2: "nurse_date",
      key3: "nurse_time",
      groups: nurseGroups, // Pass all nurses
      type: "nurse_all"
    }
  ];

  return (
    <>
      <Typography variant="h6" sx={{ marginTop: 3, mb: 2 }}>
        Signatures
      </Typography>
      <Grid container spacing={3}>
        {signatureFields.map((person, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box sx={{ p: 2, border: '1px solid #eee', borderRadius: 2, height: '100%', backgroundColor: '#fff' }}>
              <FormControl fullWidth size="small" error={!!errors[person.key1]}>
                <InputLabel>{`Name (${person.label}) *`}</InputLabel>
                <Select
                  name={person.key1}
                  value={formData[person.key1] || ''}
                  label={`Name (${person.label}) *`}
                  onChange={handleNameChange}
                  onBlur={handleBlur}
                >
                  <MenuItem value=""><em>Select {person.label}</em></MenuItem>
                  
                  {person.type === "doctor" && doctorGroups[person.group]?.map((doctor, idx) => (
                    <MenuItem key={idx} value={doctor}>{doctor}</MenuItem>
                  ))}

                  {person.type === "doctor_all" && Object.entries(person.groups).map(([specialty, doctors]) => [
                    <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                    doctors.map((doctor, idx) => (
                      <MenuItem key={`${specialty}-${idx}`} value={doctor}>{doctor}</MenuItem>
                    )),
                  ])}

                  {person.type === "nurse_all" && Object.entries(person.groups).map(([department, nurses]) => [
                    <ListSubheader key={department}>{department}</ListSubheader>,
                    nurses.map((nurse, idx) => (
                      <MenuItem key={`${department}-${idx}`} value={nurse}>{nurse}</MenuItem>
                    )),
                  ])}
                </Select>
                {errors[person.key1] && <FormHelperText>{errors[person.key1]}</FormHelperText>}
              </FormControl>

              <TextField
                name={person.key2}
                value={formData[person.key2] || ''}
                fullWidth
                label={`Signature Date (${person.label})`}
                type="date"
                size="small"
                sx={{ mt: 2 }}
                InputLabelProps={{ shrink: true }}
                InputProps={{ readOnly: true }}
              />

              <TextField
                name={person.key3}
                value={formData[person.key3] || ''}
                fullWidth
                label={`Signature Time (${person.label})`}
                type="time"
                size="small"
                sx={{ mt: 2 }}
                InputLabelProps={{ shrink: true }}
                InputProps={{ readOnly: true }}
              />

              <Button
                variant="outlined"
                fullWidth
                sx={{ mt: 2, color: '#008080', borderColor: '#008080' }}
                onClick={() => handleSignatureOpen(person.key)}
              >
                {formData[person.key] ? 'Update Signature' : 'Sign Here'}
              </Button>

              {formData[person.key] && (
                <Box sx={{ mt: 2, border: "1px solid #ccc", borderRadius: 1, p: 1, textAlign: 'center' }}>
                  <img
                    src={`data:image/png;base64,${formData[person.key]}`}
                    alt="Signature"
                    style={{ maxHeight: '60px', maxWidth: '100%' }}
                  />
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default SignaturesSection;
